<template>
<v-container fluid fill-height>    
    <v-layout v-if="loading" align-center justify-center>
        <v-progress-circular indeterminate></v-progress-circular>
    </v-layout>
    <v-layout v-else>
        <v-flex xs12>
            <v-card>
                <v-toolbar color="primary" class="white--text">
                    <v-toolbar-title>Berries Forecast Note/Alert Categorys</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-icon dark>layers</v-icon>
                </v-toolbar>
                <v-layout wrap>
                    <v-flex xs12>
                        <v-alert :value="error != null" outline type="error">``
                            {{error}}
                        </v-alert>
                    </v-flex>
                    <v-flex xs12 sm3 offset-sm1>
                        <v-text-field v-model="search" append-icon="search" label="Filter" single-line hide-details></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3 offset-sm1>
                        <v-checkbox class="active-checkbox" label="Active Only" v-model="activeOnly" hide-details></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm2 offset-sm1>
                        <v-btn color="primary" block @click="showEditAddberriesForecastNoteAlertCategories({})">
                            Add
                        </v-btn>
                    </v-flex>
                </v-layout>
                <v-layout pt-3>
                    <v-flex xs12>
                        <v-data-table :headers="headers" :items="filteredBerriesForecastNoteAlertCategories" :search="search" :rows-per-page-items="rowsPerPageItems" :pagination.sync="pagination" must-sort>
                            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                            <template slot="items" slot-scope="props">
                                <td>{{props.item.CategoryName}}</td>
                                <td>{{props.item.Description}}</td>
                                <td>{{props.item.Active ? 'Active' : 'Inactive'}}</td>
                                <td>
                                    <v-btn color="primary" block @click="showEditAddberriesForecastNoteAlertCategories(props.item)">
                                        Edit
                                    </v-btn>
                                </td>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
    </v-layout>
    <v-dialog v-model="showAddEditBerriesForecastNoteAlertCategoryDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon dark :disabled="saving" @click="cancelEdit">
                    <v-icon large>close</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-toolbar-title v-if="editing">Edit Berries Forecast Note/Alert Category</v-toolbar-title>
                <v-toolbar-title v-else>Add New Berries Forecast Note/Alert Category</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                </v-toolbar-items>
            </v-toolbar>
            <v-form ref="editForm" v-model="editValid">
                <v-layout class="dialog-content">
                    <v-flex xs12 md6 offset-md3 mt-4>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field v-model="editItem.CategoryName" :rules="[rules.required, rules.maxFiveHundredCharacters]" counter label="Category Name">
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field v-model="editItem.Description" :rules="[rules.maxFiveHundredCharacters]" label="Description">
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-checkbox v-model="editItem.Active" label="Status"></v-checkbox>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap class="dialog-action-buttons">
                            <v-flex xs12 sm6>
                                <v-btn block color="success" :disabled="!editValid" :loading="saving" @click="save(editItem)">Save</v-btn>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-btn block color="error" :disabled="saving" @click="cancelEdit">Cancel</v-btn>
                            </v-flex>
                            <v-flex xs12>
                                <v-alert :value="error != null" outline type="error">
                                    {{error}}
                                </v-alert>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-card>
    </v-dialog>
</v-container>
</template>

<script>
import api from '@/api/configurationApi'
import validationRules from "@/helpers/validationrules";

export default {
    data() {
        return {
            berriesForecastNoteAlertCategories: [],
            editItem: {},
            loading: false,
            search: '',
            activeOnly: true,
            showAddEditBerriesForecastNoteAlertCategoryDialog: false,
            rules: validationRules.rules,
            editing: false,
            editValid: true,
            saving: false,
            error: null,
            rowsPerPageItems: [10, 25, 50, 100],
            pagination: {
                page: 1,
                rowsPerPage: 25,
                descending: false
            },
            headers: [
                {
                    text: "Category Name",
                    value: "CategoryName",
                    align: 'left'
                },
                {
                    text: "Description",
                    value: "Description",
                    align: 'left'
                },
                {
                    text: "Active Status",
                    value: "Active",
                    align: 'left'
                },
                {
                    text: "Edit",
                    value: "",
                    align: "left",
                    sortable: false
                }
            ]
        }
    },
    computed: {
        filteredBerriesForecastNoteAlertCategories() {
            return this.berriesForecastNoteAlertCategories.filter(c => c.Active || !this.activeOnly);
        }
    },
    methods: {
        async loadBerriesForecastNoteAlertCategories() {
            this.loading = true;
            this.error = null;

            try {
                this.berriesForecastNoteAlertCategories = await api.getBerriesForecastNoteAlertCategories();
            } catch(err) {
                this.error = err;
            }

            this.loading = false;
        },
        async showEditAddberriesForecastNoteAlertCategories(item) {
            Object.assign(this.editItem, item);
            this.showAddEditBerriesForecastNoteAlertCategoryDialog = true;
        },
        async save(item) {
            this.saving = true;
            this.error = null;

            try {
                let response = {};

                if(item.BerriesForecastNoteAlertCategoryID) {
                    response = await api.updateBerriesForecastNoteAlertCategory(item);
                } else {
                    response = await api.addBerriesForecastNoteAlertCategory(item);
                }

                if(!response.Success) {
                    this.error = response.ErrorMessages.join(', ');
                    return;
                }
            } catch(err) {                
                this.error = err;
                return;
            } finally {
                this.saving = false;
            }

            this.showAddEditBerriesForecastNoteAlertCategoryDialog = false;
            this.editItem = {};
            this.$refs.editForm.reset();
            await this.loadBerriesForecastNoteAlertCategories();            
        },
        async cancelEdit() {
            this.editItem = {};
            this.showAddEditBerriesForecastNoteAlertCategoryDialog = false;
            this.error = null;
            this.$refs.editForm.reset();
        }
    },
    async created() {
        await this.loadBerriesForecastNoteAlertCategories();
    }
}
</script>
